import React from 'react';

const Compteur = ({ cle, value }) => {
    return (
        <span key={cle} className="badge badge-info w-10">
            {value}
        </span>
    );
};

export default Compteur;
